import React from "react"

export enum PopoverRoot {
  DEFAULT_POPOVER_ROOT = "popover-root",
  OVERLAY_POPOVER_ROOT = "overlay-popover-root"
}

export const PopoverContext = React.createContext<string>(
  PopoverRoot.DEFAULT_POPOVER_ROOT
)
